(function () {
    'use strict';

    angular.module("imApp").factory("selectLabourService", [function () {
        let service = {};

        return service;
    }]);
})();
